import {components} from 'react-select'
import React from 'react'

export const Input = (props) => <components.Input {...props} isHidden={false} />
